<!-- 周期检打印 -->
<template>
  <h-print>
    <template #header>
      <div class="print-header">
        <div>{{ time(new Date(), 6) }}</div>
        <div>{{ h_i18n('e611f28433d9f38ef0ccde8d60c84bdd') }}</div>
        <div></div>
      </div>
    </template>
    <h-inspection-page
      :title="h_i18n('e611f28433d9f38ef0ccde8d60c84bdd')"
      @inspection-update="inspectionUpdate"
    >
      <inspection-header :title="h_i18n('e611f28433d9f38ef0ccde8d60c84bdd')" title-height="80px">
        <template #title>
          <h-p align="left" style="margin-left: 10px" :title="h_i18n('c515f3385e7740c52e22eefc10b62f2b')">
            {{ detailObj.claimCode }}
          </h-p>
        </template>
        <template #body>
          <tr>
            <h-td :title="h_i18n('03490f3868798323211aa633194df2c1')">{{ detailObj.sybName }}</h-td>
            <h-td :title="h_i18n('41716f87c3755bab459a2cbc7219e60c')">{{ detailObj.factoryCode }}</h-td>
            <h-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')">{{ detailObj.supplyCode }}</h-td>
          </tr>
          <tr>
            <h-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')">{{ detailObj.supplyName }}</h-td>
            <h-td :title="h_i18n('ec46bb5e826a9e2d3dd26aad97946925')">{{ detailObj.claimTypeName }}</h-td>
            <h-td :title="h_i18n('21f695cfda35456de5403862989d74a8')">{{ detailObj.claimMoney }}</h-td>
          </tr>
          <tr>
            <h-td :title="h_i18n('146a18381105d881060cb68aaf307bde')">{{ detailObj.isrtEmpName.toLowerCase() === 'system' ? detailObj.isrtEmpName : '*' }}</h-td>
            <h-td :title="h_i18n('56816285254449739e6084ea6259ed00')">{{ detailObj.isrtDate }}</h-td>
            <h-td :title="h_i18n('e3d41c21207f58954b4a237a94e9fd54')">{{ detailObj.jhStateName }}</h-td>
          </tr>
          <tr v-if="detailObj.caFileUuid">
            <h-td :title="h_i18n('e38dc9a7595ba64e09896c66f1bcb598')" colspan="5">
              <span class="blue-text">{{ detailObj.caFileName }}</span>
            </h-td>
          </tr>
          <tr>
            <h-td :title="h_i18n('bab666a374cf12bd14d81817a534d9b4')">{{ h_i18n('599f3d5e60f1c278032a33aabba602f6') }}</h-td>
            <h-td :title="h_i18n('1e496c1706e113b19791411c33cbc6a3')">{{ detailObj.confirmName }}</h-td>
            <h-td :title="h_i18n('36a5d2e23d3454167254f10a406f059d')">{{ detailObj.confirmDate }}</h-td>
          </tr>
        </template>
      </inspection-header>
      <inspection-body>
        <table
          border="0"
          cellpadding="0"
          cellspacing="0"
          width="0"
          style="margin-top: 10px; width: 100%"
        >
          <colgroup>
            <col width="100" />
            <col width="110" />
            <col />
            <col width="100" />
            <col width="200" />
            <col width="100" />
            <col width="100" />
            <col width="148" />
            <col width="100" v-if="detailObj.claimType != 1427" />
          </colgroup>
          <thead>
            <tr class="h-tr-d">
              <th rowspan="2">{{ h_i18n('96ad1b86c31e8f1965a3fdafae75975d') }}</th>
              <th rowspan="2">{{ h_i18n('56ca9a2de6d54b00fb98ab39cce17089') }}</th>
              <th rowspan="3">{{ h_i18n('901fcadda8a5683e7a83a0c811ff4382') }}</th>
              <th rowspan="2">{{ h_i18n('93088b3ee041cfcf2c25b1b3ddd5fef1') }}</th>
              <th rowspan="2">{{ h_i18n('b379842b1845387b6609022e7d834182') }}</th>
              <th rowspan="2">{{ h_i18n('111bf3546339b7d2a454e514828daf98') }}</th>
              <th rowspan="2">{{ h_i18n('92c95a3945fe66d44102305d7043b0e6') }}</th>
              <th rowspan="2">{{ h_i18n('1bbe6ebe11a361d576f88cda2d2e32b8') }}</th>
              <th rowspan="2" v-if="detailObj.claimType != 1427">{{ h_i18n('eec9575cbb72f7ffd775c3a20ca9cf1e') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in claimDetailList"
              class="h-tr-d"
              :key="index"
            >
              <td>{{ row.sendGoodsNo }}</td>
              <td>{{ row.mtlNo }}</td>
              <td>{{ row.mtlName }}</td>
              <td>{{ row.claimTypeName }}</td>
              <td>{{ row.claimReason }}</td>
              <td>{{ row.claimCount }}</td>
              <td>{{ row.claimMoney }}</td>
              <td>{{ row.sendDay }}</td>
              <td v-if="detailObj.claimType != 1427">
                {{ row.iqcManagerName ? "*" : ''}}
              </td>
            </tr>
          </tbody>
        </table>
      </inspection-body>
    </h-inspection-page>
  </h-print>
</template>


<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

export default {
  name: 'PeriodicPrint',
  data() {
    return {
      detailObj: {},
      editFlag: false,
      claimDetailList: [],
      signatureObj: {}
    };
  },
  methods: {
    h_i18n,
    print() {
      setTimeout(() => {
        window.print();
        this.tableLoading = false;
      }, 200);
    },
    //new--
    //时间截取
    formDate(val, len = 3) {
      if (val) {
        return this.time(val, len);
      } else {
        return '';
      }
    },

    inspectionUpdate() {
      this.postThisPageHeight();
    },

    getDetail() {
      this.$http({
        url: '/base/qualityClaim/getDetailById',
        method: 'get',
        params: {
          id: this.$route.query.claimCode
        }
      })
        .then((res) => {
          if (res.data.data) {
            this.detailObj = res.data.data;
            this.claimDetailList = res.data.data.claimDetailList || [];
          }

          this.print();
        })
        .catch((err) => {
          this.warning({ message: err ? err : h_i18n('0d66ed02d74d0bd89431d6d59533ffb3'), title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770') });
        });
    },
    // 获取签章信息
    getSignatureInfo() {
      return this.$http({
        url: `/base/claimConfirm/getClaimConfirmInfo?claimCode=${this.$route.query.claimCode}`,
        method: 'get'
      })
        .then((res) => {
          if (res.data.code == 0) {
            console.log('=========获取签章信息了', res.data);
            this.$nextTick(() => {
              this.signatureObj = Object.assign({}, { ...res.data.data });
            });
          }
        })
        .catch((err) => {
          this.info({ message: err ? err : h_i18n('8e66e95910ab41cf44496adb1c40277f'), title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770') });
        });
    }
  },
  created() {
    window.addEventListener('beforeinput', () => {});
    window.addEventListener('afterprint', () => {
      window.close();
    });
  },
  mounted() {
    let roleCode =
      this.$route && this.$route.query && this.$route.query.roleCode
        ? this.$route.query.roleCode
        : '';
    console.log('roleCode', roleCode);
    if (roleCode.indexOf('S') == 0) {
      if (roleCode == 'S009') {
        this.editFlag = true;
      }
    }
    this.getSignatureInfo();
    this.getDetail();
  },
  activated() {}
};
</script>

<style src="@/assets/css/new.scss" lang="scss"></style>

<style lang="scss">
.tr_2in1_style {
  .haier-td:last-child {
    padding: 0;
  }
  .no_border_style {
    .haier-td {
      border: 0;
      line-height: 43px;
    }
  }
  .one_border_style {
    .haier-td {
      line-height: 43px;
      border: 0;
    }
    border-bottom: 1px solid #ccc;
  }
}
/* body {overflow:auto !important} */
.haier-inspection-header
  .haier-table
  .haier-table-header
  .haier-table-header--right {
  width: calc((100% / 6) * 2 - 1px) !important;
}
.haier-title-lable {
  display: none !important;
}
.haier-td {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 4px 10px;
  font-size: 14px;
  height: 35px;
  color: #666;
}

.is-right {
  text-align: right;
}
</style>

<style lang="scss" scoped>
.h-global-font-blue-disabled {
  color: #b6d5ff;
  cursor: not-allowed;
}

.haier-inspection-footer {
  position: relative;
}

.row-disabled {
  background-color: #eee;
}

.row-error {
  background-color: #fff0f0;
}

.vxe-table--render-default .vxe-body--column.col--ellipsis,
.vxe-table--render-default.vxe-editable .vxe-body--column,
.vxe-table--render-default .vxe-footer--column.col--ellipsis,
.vxe-table--render-default .vxe-header--column.col--ellipsis {
  height: 48px !important;
}

.h-tr-d {
  th {
    height: 22px;
    padding: 5px 4px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    table-layout: fixed;
  }

  td {
    height: 36px;
    padding: 5px 4px;
    font-size: 14px;
    color: #606266;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    table-layout: fixed;
    text-align: center;
  }

  td:first-child {
    border-left: 1px solid #ccc;
  }
}

.h-tr-d:first-child {
  th:first-child {
    border-left: 1px solid #ccc;
  }
}

.h-tr-d:first-child {
  th {
    border-top: 1px solid #ccc;
  }
}

.h-tr-d-n {
  th {
    height: 33px;
    padding: 5px 4px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    table-layout: fixed;
  }

  td {
    height: 33px;
    padding: 5px 4px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    table-layout: fixed;
  }
}

.print-header {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.input_13 {
  flex: none;
  width: 40px !important;
  transition: all 200ms ease-in-out;
  text-indent: 5px;
}
.input_13 .el-input__inner {
  text-align: center !important;
}
.input_borrow_input {
  text-indent: 10px;
  text-align: left;
}
.check_true {
  width: 200px !important;
  flex: none;
}
</style>